module.exports = __webpack_public_path__ + "685d500449e9631f007553a3c0860cd8.png";